import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import MainAuth from './routes/auth/SignIn.js';
import MainApp from './routes/application/index.js';
import ForgotPassword from './routes/auth/ForgotPassword';

import AuthProvider, { AuthIsSignedIn, AuthIsNotSignedIn } from './contexts/authContext';
import AppAuthContext from './contexts/AppAuthContext.tsx';

import NotificationProvider from './contexts/NotificationContext';
import NotificationSnackbar from './components/NotificationSnackbar';

const App = () => {
	return (
		<div className="app-main">
			<AuthProvider>
				<NotificationProvider>
					<NotificationSnackbar />
					<AuthIsSignedIn>
						<AppAuthContext>
							<BrowserRouter>
								<Routes>
									<Route path='/*' element={<MainApp/>}/>
								</Routes>
							</BrowserRouter>
						</AppAuthContext>
					</AuthIsSignedIn>
					<AuthIsNotSignedIn>
						<BrowserRouter>
							<Routes>
								<Route path='/forgot-password' element={<ForgotPassword/>}/>
								<Route path='/*' element={<MainAuth/>}/>
							</Routes>
						</BrowserRouter>
					</AuthIsNotSignedIn>
				</NotificationProvider>
			</AuthProvider>
		</div>
	);
}

export default App;
